module.exports = __webpack_public_path__ + "img/wechat.93081468.png";